module.exports = __webpack_public_path__ + "assets/LM3D-Swim-36e7b6d48cf278c42ade42e579afbdac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/LM3D-Swim.jpg
// module id = 506
// module chunks = 1